export default __webpack_public_path__ + "static/media/light-bulb.306031b7.svg";